import request from '../request';

export const addAdditionalServices = (data) => {
  return request({
    url: '/service/cart/add-additionals',
    data,
    type: 'POST',
  });
};

export const addAdditionalServicesInfo = (extraInfo, uid) => {
  return request({
    url: '/service/cart/save-extra-info',
    data: {
      uid: uid,
      extraInfo: extraInfo,
    },
    type: 'POST',
  });
};